import React from 'react';
import { FormControl, Select, MenuItem, withStyles } from '@material-ui/core';
import { VOICE_CALL } from '../../../../constants/voice-call-constants';
import styles from './minute-cap-period-select.style';

const MinuteCapPeriodSelect = ({ classes, value, onChange, disabled, id = 'minute-cap-period' }) => {
  const options = VOICE_CALL.getMinuteCapPeriodMenuLabels();
  const v = (value || VOICE_CALL.MINUTE_CAP_PERIOD.DAILY).toUpperCase();
  return (
    <FormControl variant="outlined" className={classes.root} size="small" disabled={disabled}>
      <Select
        id={id}
        value={v}
        onChange={(e) => onChange(e.target.value)}
        className={classes.select}
        classes={{ icon: classes.icon }}
        data-testid="minute-cap-period-select"
        MenuProps={{
          elevation: 0,
          disableAutoFocus: true,
          classes: { paper: classes.menuPaper, list: classes.menuList },
          getContentAnchorEl: null,
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          transformOrigin: { vertical: 'top', horizontal: 'right' },
          marginThreshold: 8,
        }}
      >
        {options.map((o) => (
          <MenuItem
            key={o.value}
            value={o.value}
            className={classes.menuItem}
            data-testid={`minute-cap-${o.value}`}
          >
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default withStyles(styles)(MinuteCapPeriodSelect);
